// extracted by mini-css-extract-plugin
export var hitLink = "styles-module__hitLink___wwVUz";
export var name = "styles-module__name___HCSJj";
export var searchText = "styles-module__searchText___Uwq2_";
export var selected = "styles-module__selected___pQsCx";